import { InvalidArgumentException, InvalidOperationException } from "../Base/Exceptions";
import { Globalization, ICultureInfo, INumberFormatInfoOrienation } from "./Globalization";

export class CultureInfo {
    private static _actualCulture: string;
    private static _actualCultureInfo: ICultureInfo;

    public static hasI18N: boolean; // jestli browser podporuje Internacionalizaci

    // seznam kultur a informaci
    private static readonly _cultureInfos: { [culture: string]: ICultureInfo } = {
        "cs-CZ": {
            name: "cs-CZ",
            englishName: "Czech (Czech Republic)",
            nativeName: "čeština (Česká republika)",
            numberFormat: {
                decimalSeparator: ",",
                groupSeparator: " ",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "Kč"
                //CurrencyNegativePattern
                //CurrencyPositivePattern
            },
            dateTimeFormat: {
                monthNames: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"],
                abbreviatedMonthNames: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
                dayNames: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"],
                abbreviatedDayNames: ["ne", "po", "út", "st", "čt", "pá", "so"],
                amDesignator: "dop.",
                pmDesignator: "odp.",
                formatPatterns: {
                    shortDate: "d.M.yyyy",
                    longDate: "d. MMMM yyyy",
                    shortTime: "H:mm",
                    longTime: "H:mm:ss",
                    fullDateTime: "d. MMMM yyyy H:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "dd MMMM",
                    yearMonth: "MMMM yyyy",
                },
            },
        },
        "sk-SK": {
            name: "sk-SK",
            englishName: "Slovak (Slovakia)",
            nativeName: "slovenčina (Slovenská republika)",
            numberFormat: {
                decimalSeparator: ",",
                groupSeparator: " ",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "€"
            },
            dateTimeFormat: {
                monthNames: ["január", "február", "marec", "apríl", "máj", "jún", "júl", "august", "september", "október", "november", "december"],
                abbreviatedMonthNames: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
                dayNames: ["nedeľa", "pondelok", "utorok", "streda", "štvrtok", "piatok", "sobota"],
                abbreviatedDayNames: ["ne", "po", "ut", "st", "št", "pi", "so"],
                amDesignator: "",
                pmDesignator: "",
                formatPatterns: {
                    shortDate: "d.M.yyyy",
                    longDate: "d. MMMM yyyy",
                    shortTime: "H:mm",
                    longTime: "H:mm:ss",
                    fullDateTime: "d. MMMM yyyy H:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "dd MMMM",
                    yearMonth: "MMMM yyyy",
                },
            },
        },
        "en-US": {
            name: "en-US",
            englishName: "English (United States)",
            nativeName: "English (United States)",
            numberFormat: {
                decimalSeparator: ".",
                groupSeparator: ",",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "$"
            },
            dateTimeFormat: {
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                abbreviatedMonthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                abbreviatedDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                amDesignator: "AM",
                pmDesignator: "PM",
                formatPatterns: {
                    shortDate: "M/d/yyyy",
                    longDate: "dddd, MMMM dd, yyyy",
                    shortTime: "h:mm tt",
                    longTime: "h:mm:ss tt",
                    fullDateTime: "dddd, MMMM dd, yyyy h:mm:ss tt",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "MMMM dd",
                    yearMonth: "MMMM, yyyy",
                },
            },
        },
        "en-GB": {
            name: "en-GB",
            englishName: "English (United Kingdom)",
            nativeName: "English (United Kingdom)",
            numberFormat: {
                decimalSeparator: ".",
                groupSeparator: ",",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "£"
            },
            dateTimeFormat: {
                monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                abbreviatedMonthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                abbreviatedDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                amDesignator: "AM",
                pmDesignator: "PM",
                formatPatterns: {
                    shortDate: "dd/MM/yyyy",
                    longDate: "dd MMMM yyyy",
                    shortTime: "HH:mm",
                    longTime: "HH:mm:ss",
                    fullDateTime: "dd MMMM yyyy HH:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "dd MMMM",
                    yearMonth: "MMMM yyyy",
                },
            },
        },
        "pl-PL": {
            name: "pl-PL",
            englishName: "Polish (Poland)",
            nativeName: "polski (Polska)",
            numberFormat: {
                decimalSeparator: ".",
                groupSeparator: ",",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "zł"
            },
            dateTimeFormat: {
                monthNames: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                abbreviatedMonthNames: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"],
                dayNames: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"],
                abbreviatedDayNames: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
                amDesignator: "",
                pmDesignator: "",
                formatPatterns: {
                    shortDate: "yyyy-MM-dd",
                    longDate: "d MMMM yyyy",
                    shortTime: "HH:mm",
                    longTime: "HH:mm:ss",
                    fullDateTime: "d MMMM yyyy HH:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "d MMMM",
                    yearMonth: "MMMM yyyy",
                },
            },
        },
        "de-DE": {
            name: "de-DE",
            englishName: "German (Germany)",
            nativeName: "Deutsch (Deutschland)",
            numberFormat: {
                decimalSeparator: ",",
                groupSeparator: ".",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "€"
            },
            dateTimeFormat: {
                monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
                abbreviatedMonthNames: ["Jan", "Feb", "Mrz", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
                dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
                abbreviatedDayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                amDesignator: "",
                pmDesignator: "",
                formatPatterns: {
                    shortDate: "dd.MM.yyyy",
                    longDate: "dddd, d. MMMM yyyy",
                    shortTime: "HH:mm",
                    longTime: "HH:mm:ss",
                    fullDateTime: "dddd, d. MMMM yyyy HH:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "dd MMMM",
                    yearMonth: "MMMM yyyy",
                },
            },
        },
        "de-AT": {
            name: "de-AT",
            englishName: "German (Austria)",
            nativeName: "Deutsch (Österreich)",
            numberFormat: {
                decimalSeparator: ",",
                groupSeparator: " ",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "€"
            },
            dateTimeFormat: {
                monthNames: ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
                abbreviatedMonthNames: ["Jän", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
                dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
                abbreviatedDayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                amDesignator: "",
                pmDesignator: "",
                formatPatterns: {
                    shortDate: "dd.MM.yyyy",
                    longDate: "dddd, dd. MMMM yyyy",
                    shortTime: "HH:mm",
                    longTime: "HH:mm:ss",
                    fullDateTime: "dddd, dd. MMMM yyyy HH:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "dd MMMM",
                    yearMonth: "MMMM yyyy",
                },
            },
        },
        "hu-HU": {
            name: "hu-HU",
            englishName: "Hungarian (Hungary)",
            nativeName: "magyar (Magyarország)",
            numberFormat: {
                decimalSeparator: ",",
                groupSeparator: " ",
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
                //currencySymbol: "Ft"
            },
            dateTimeFormat: {
                monthNames: ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"],
                abbreviatedMonthNames: ["jan.", "febr.", "márc.", "ápr.", "máj.", "jún.", "júl.", "aug.", "szept.", "okt.", "nov.", "dec."],
                dayNames: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"],
                abbreviatedDayNames: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
                amDesignator: "de.",
                pmDesignator: "du.",
                formatPatterns: {
                    shortDate: "yyyy. MM. dd.",
                    longDate: "yyyy. MMMM d.",
                    shortTime: "H:mm",
                    longTime: "H:mm:ss",
                    fullDateTime: "yyyy. MMMM d. H:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "MMMM d.",
                    yearMonth: "yyyy. MMMM",
                },
            },
        },
        "ru-RU": {
            name: "ru-RU",
            englishName: "Russian (Russia)",
            nativeName: "русский (Россия)",
            numberFormat: {
                decimalSeparator: ",",
                groupSeparator: " ",
                //currencySymbol: "руб."
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
            },
            dateTimeFormat: {
                monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                abbreviatedMonthNames: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"],
                dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
                abbreviatedDayNames: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
                amDesignator: "",
                pmDesignator: "",
                formatPatterns: {
                    shortDate: "dd.MM.yyyy",
                    longDate: "d MMMM yyyy 'г.'",
                    shortTime: "H:mm",
                    longTime: "H:mm:ss",
                    fullDateTime: "d MMMM yyyy 'г.' H:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "MMMM dd",
                    yearMonth: "MMMM yyyy 'г.'",
                },
            },
        },
        "uk-UA": {
            name: "uk-UA",
            englishName: "Ukrainian (Ukraine)",
            nativeName: "україньска (Україна)",
            numberFormat: {
                decimalSeparator: ",",
                groupSeparator: " ",
                //currencySymbol: "₴"
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
            },
            dateTimeFormat: {
                monthNames: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
                abbreviatedMonthNames: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
                dayNames: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п'ятниця", "субота"],
                abbreviatedDayNames: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
                amDesignator: "",
                pmDesignator: "",
                formatPatterns: {
                    shortDate: "dd.MM.yyyy",
                    longDate: "d MMMM yyyy' р.'",
                    shortTime: "H:mm",
                    longTime: "H:mm:ss",
                    fullDateTime: "d MMMM yyyy' р.' H:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "d MMMM",
                    yearMonth: "MMMM yyyy' р.'",
                },
            },
        },
        "ms-MY": { // pridano pro testovani, aby byl oznacen jako validni jazyk
            name: "ms-MY",
            englishName: "	Malaysian",
            nativeName: "بهاس مليسيا",
            numberFormat: {
                decimalSeparator: ".",
                groupSeparator: ",",
                //currencySymbol: "MYR"
                groupSize: 3,
                secondaryGroupSize: 3,
                orientation: INumberFormatInfoOrienation.leftToRight,
                numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                useArabicNumbers: true,
                positions: {
                    minus: "- #cv#",
                },
            },
            dateTimeFormat: {
                monthNames: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
                abbreviatedMonthNames: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
                dayNames: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п'ятниця", "субота"],
                abbreviatedDayNames: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
                amDesignator: "",
                pmDesignator: "",
                formatPatterns: {
                    shortDate: "dd.MM.yyyy",
                    longDate: "d MMMM yyyy' р.'",
                    shortTime: "H:mm",
                    longTime: "H:mm:ss",
                    fullDateTime: "d MMMM yyyy' р.' H:mm:ss",
                    sortableDateTime: "yyyy-MM-ddTHH:mm:ss",
                    universalSortableDateTime: "yyyy-MM-dd HH:mm:ssZ",
                    rfc1123: "ddd, dd MMM yyyy HH:mm:ss GMT",
                    monthDay: "d MMMM",
                    yearMonth: "MMMM yyyy' р.'",
                },
            },
        },
    };

    public static setCulture(culture: string): void {
        Globalization.actualCulture = culture;
        let cI: ICultureInfo = CultureInfo._cultureInfos[culture];
        if (typeof cI === "undefined") {
            const c = culture.split("-");
            cI = CultureInfo._cultureInfos[c[0]];
            if (typeof cI === "undefined")
                throw new InvalidOperationException("invalid culture");
        }

        CultureInfo._actualCulture = culture;
        CultureInfo._actualCultureInfo = cI;
    }

    /**
     * Struktura s aktuálně použitou kulturou
     */
    public static getCultureInfo(): ICultureInfo {
        return CultureInfo._actualCultureInfo;
    }

    /**
     * Kód aktuálně použité kultury
     */
    public static getCulture(): string {
        return CultureInfo._actualCulture;
    }

    public static getStandardDateTimeFormat(shortFormat: string): string {
        const fp = CultureInfo._actualCultureInfo.dateTimeFormat.formatPatterns;
        switch (shortFormat) {
            case "d": // Short date pattern
                return fp.shortDate;
            case "D": // Long date pattern
                return fp.longDate;
            case "f": // Full date / time pattern(short time)
                return fp.longDate + " " + fp.shortTime;
            case "F": // Full date / time pattern(long time)
                return fp.fullDateTime;
            case "g": // General date / time pattern(short time)
                return fp.shortDate + " " + fp.shortTime;
            case "G": // General date / time pattern(long time)
                return fp.shortDate + " " + fp.longTime;
            case "M":
            case "m": // Month / day pattern
                return fp.monthDay;

            //TODO: smazat
            case "O":
            case "o": // Round - trip date / time pattern.
                return "yyyy-MM-ddTHH:mm:ss.fffffff";
            case "R":
            case "r": // Round - trip date / time pattern.
                return fp.monthDay + " " + "yyyy" + " " + fp.shortTime;
            //TODO: smazat
            case "s": // Sortable date/time pattern
                return fp.sortableDateTime;

            case "t": // Short time pattern
                return fp.shortTime;
            case "T": // Long time pattern
                return fp.longTime;

            //TODO: smazat
            case "u": // Universal sortable date/time pattern
                return fp.universalSortableDateTime;

            //TODO: smazat
            case "U": // Universal full date / time pattern
                return fp.fullDateTime;
            case "Y":
            case "y": // Year month pattern
                return fp.yearMonth;
        }

        throw new InvalidArgumentException("shortFormat");
    }

    public static getStandardDateTimeOptions(shortFormat: string): Intl.DateTimeFormatOptions {
        switch (shortFormat) {
            case "d": // Short date pattern
                return {
                    //year: 'numeric', month: '2-digit', day: '2-digit'
                    year: "numeric", month: "numeric", day: "numeric",
                };
            case "D": { // Long date pattern
                const n = CultureInfo._actualCultureInfo.name;
                return (n === "en-US" || n === "de-DE" || n === "de-AT")
                    ? { year: "numeric", month: "long", day: "numeric", weekday: "long" }
                    : { year: "numeric", month: "long", day: "numeric" };
            }
            case "f": { // Full date / time pattern(short time)
                const d: any = CultureInfo.getStandardDateTimeOptions("D");
                const t: any = CultureInfo.getStandardDateTimeOptions("t");
                for (const att in t) {
                    if (Object.prototype.hasOwnProperty.call(t, att)) {
                        d[att] = t[att];
                    }
                }
                return d;
            }
            case "F": { // Full date / time pattern(long time)
                const d: any = CultureInfo.getStandardDateTimeOptions("D");
                const t: any = CultureInfo.getStandardDateTimeOptions("T");
                for (const att in t) {
                    if (Object.prototype.hasOwnProperty.call(t, att)) {
                        d[att] = t[att];
                    }
                }
                return d;
            }
            case "g": // General date / time pattern(short time)
                return { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" };
            //return { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            case "G": // General date / time pattern(long time)
                return { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric" };
            //return { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            case "M":
            case "m": // Month / day pattern
                //return { month: 'long', day: '2-digit' };
                return { month: "long", day: "numeric" };
            case "t": // Short time pattern
                return { hour: "numeric", minute: "2-digit" };
            //return { hour: '2-digit', minute: '2-digit' };
            case "T": // Long time pattern
                //return { hour: '2-digit', minute: '2-digit', second: '2-digit' };
                return { hour: "numeric", minute: "2-digit", second: "2-digit" };
            case "U": { // Universal full date / time pattern
                const o = CultureInfo.getStandardDateTimeOptions("F");
                if (o) o.timeZone = "UTC";
                return o;
            }
            case "Y":
            case "y": // Year month pattern
                return { year: "numeric", month: "long" };
        }

        throw new InvalidArgumentException("shortFormat");
    }

    // nahrada za staticky konstruktor
    public static init(): void {
        CultureInfo._cultureInfos["cs"] = CultureInfo._cultureInfos["cs-CZ"];
        CultureInfo._cultureInfos["pl"] = CultureInfo._cultureInfos["pl-PL"];
        CultureInfo._cultureInfos["de"] = CultureInfo._cultureInfos["de-DE"];
        CultureInfo._cultureInfos["en"] = CultureInfo._cultureInfos["en-US"];
        CultureInfo._cultureInfos["hu"] = CultureInfo._cultureInfos["hu-HU"];
        CultureInfo._cultureInfos["ru"] = CultureInfo._cultureInfos["ru-RU"];
        CultureInfo._cultureInfos["uk"] = CultureInfo._cultureInfos["uk-UA"];

        if (!CultureInfo._actualCulture)
            CultureInfo.setCulture("cs");

        CultureInfo.hasI18N = !!(self as any).Intl;
    }
}

CultureInfo.init();

//interface Window {
//    Intl: any;
//}
